import { marshall, unmarshall } from '@aws-sdk/util-dynamodb';

export const copyArray = (array) => {
    const newArray = [];
    for (let i = 0; i < array.length; i++) {
        newArray[i] = array[i];
    }
    return newArray;
};

export const sortByLabel = (a,b) => (a.Label > b.Label) ? 1 : ((b.Label > a.Label) ? -1 : 0);
export const sortByOrder = (a,b) => (a.displayOrder > b.displayOrder) ? 1 : ((b.displayOrder > a.displayOrder) ? -1 : 0);
export const sortColumnsByLabel = (a,b) => (a.Label.S > b.Label.S) ? 1 : ((b.Label.S > a.Label.S) ? -1 : 0);
export const sortByJob = (a,b) => (a.jobNumVendor > b.jobNumVendor) ? 1 : ((b.jobNumVendor > a.jobNumVendor) ? -1 : 0);

export const sortSourceColumnsByDisplayOrder = (a,b) => {
    const anum = parseInt(a.M.DisplayOrder.N,10);
    const bnum = parseInt(b.M.DisplayOrder.N,10);
    return (anum > bnum) ? 1 : ((bnum > anum) ? -1 : 0);
};

export const sortColumnsByDisplayOrder = (a,b) => {
    const anum = parseInt(a.DisplayOrder.N,10);
    const bnum = parseInt(b.DisplayOrder.N,10);
    return (anum > bnum) ? 1 : ((bnum > anum) ? -1 : 0);
};

export const sortTemplatesByLabel = (a, b) => {
    if (a.label < b.label) {
        return -1;
    }
    if (a.label > b.label) {
        return 1;
    }
    return 0;
};

export const guid = () => {
    var d = new Date().getTime();
    if (typeof performance !== 'undefined' && typeof performance.now === 'function') {
        d += performance.now(); //use high-precision timer if available
    }
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c === 'x' ? r : ((r & 0x3) | 0x8)).toString(16);
    });         
}
/*export const guid = () => {
    function s4() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }
    // return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    //     s4() + '-' + s4() + s4() + s4();
    return s4() + s4() + s4() + s4() + s4() + s4() + s4() + s4();
}*/

export const COLUMN_DATATYPE_NAMES = {
    single: 0,
    geo: 1,
    onoff: 3,
    undefined: -1
  }

export const matchColumnType = dataType =>
{
    const dt = dataType.toLowerCase();
    if (dt === "text" || dt === "guid" || dt === "datetime" || dt === "datetimenow" || dt === "meteracv" || dt === "meterdcmv" || dt === "decimal" || dt === "integer" || dt === "rfid" || dt === "meteracohms" || dt === "meteracma" || dt === "meteracmv" || dt === "meterdca" || dt === "meterdcohms" || dt === "meterdcv" || dt === "meterdcma" || dt === "meterohms") {
        return COLUMN_DATATYPE_NAMES.single;
    } else if (dt === "gps") {
        return COLUMN_DATATYPE_NAMES.geo;
    } else if (dt === "meterdcmvx2") {
        return COLUMN_DATATYPE_NAMES.onoff;
    } else if (dt === "meterdcvx2") {
        return COLUMN_DATATYPE_NAMES.onoff;
    } else {
        return COLUMN_DATATYPE_NAMES.undefined;
    }
}

export const getDataFromState = (state) => {
    return {
        survey: state.survey,
        templates: state.templates,
        isNewSurvey: state.isNewSurvey,
        selectedTemplates: state.selectedTemplates,
        selectedTemplateKey: state.selectedTemplateKey,
        // The selected survey from the choose list
        selectedSurvey: { job: "", client: "", templates: {}},
        selectedTemplatesChosenFields: state.selectedTemplatesChosenFields,
        selectedOptions: state.selectedOptions
    }
}

// If this survey has templates put them into the selected templates list
// This will ensure that it will show up in the checkbox list
// object looks like: 
// Templates.L[ M: { Columns {L:[]}, Value: {S: ""}, Label: {S: ""} } ]
export const getSelectedTemplates = (survey) => {
    const t = survey.Templates;
    let selectedTemplates = [];
    if (t && t.L && t.L.length > 0) {
        t.L.forEach(item => {
            selectedTemplates.push(item.M.Value.S);
        });
    }
    return selectedTemplates;
};

export const requiredFieldNames = (templates, key) => {
    return templates.filter((item) => item.value === key)[0].requiredColumns.map(
        (item) => {
            return {
                Label: item.M.Label.S,
                ColumnName: item.M.ColumnName.S,
                required: item.M.RequiredColumn.BOOL,
                templateDefault: item.M.TemplateDefault.BOOL,
                nullable: item.M.Nullable.BOOL,
                isSeparator: item.M.DataType.S === "Separator",
                allowSeparatorSelection: false,
                displayOrder: parseInt(item.M.DisplayOrder.N, 10)
            }
        });
};

export const templateDefaultFieldNames = (templates, key) => {
    return templates.filter((item) => item.value === key)[0].templateDefaultColumns.map(
        (item) => {
            return {
                Label: item.M.Label.S,
                ColumnName: item.M.ColumnName.S,
                required: item.M.RequiredColumn.BOOL,
                templateDefault: item.M.TemplateDefault.BOOL,
                nullable: item.M.Nullable.BOOL,
                isSeparator: item.M.DataType.S === "Separator",
                allowSeparatorSelection: false,
                displayOrder: parseInt(item.M.DisplayOrder.N, 10)
            }
        });
};

export const updateSurveyTemplate = (masterTemplates, surveyTemplate) => {
    var rtn = null;
    var st = unmarshall(surveyTemplate.M);
    //console.log(st)
    var mt = null;
    masterTemplates.forEach(function (t, i) {       
        if (t.value === st.Value && t.isActive === true) {
            mt = t;
        }
    });

    if (mt !== null) {
        var addCols = [];
        //check for missing required cols
        mt.columns.forEach(function (c, i) {            
            if (c.RequiredColumn === true) {                
                var stc = getSTCol(c.ColumnName);               
                if (stc === null) {
                    var addCol = JSON.parse(JSON.stringify(c));
                    addCols.push(addCol);                    
                }
            }
        });
       // console.log(addCols);
        addCols.forEach(function (ac, x) {
            st.Columns.push(ac);
        });
        //console.log(st);

        //remove invalid cols      
        for (let i = st.Columns.length - 1; i > -1; i--) {
            var mtCol = getMTCol(st.Columns[i].ColumnName)
            //console.log(mtCol);
            if (mtCol !== null) {
                for (var propt in mtCol) {
                    if (st.Columns[i].hasOwnProperty(propt) == false) {
                        st.Columns[i][propt] = mtCol[propt];
                    }                  
                }
                // update col display order
                st.Columns[i].DisplayOrder = mtCol.DisplayOrder;
                //update required col
                st.Columns[i].RequiredColumn = mtCol.RequiredColumn;
                if (st.Columns[i].SelectList == null ) {
                    st.Columns[i].SelectList = mtCol.SelectList;
                }
            }
            else {
                // remove invalid col
                st.Columns.splice(i, 1);
            }
        }
        rtn = { M: marshall(st) };
        //console.log(rtn);
    }

    function getMTCol(name) {
        var mtCol = null;
        mt.columns.forEach(function (c, i) {
            if (c.ColumnName === name) {
                mtCol = c;
            }
        });
        return mtCol;
    }

    function getSTCol(name) {
        var stCol = null;
        st.Columns.forEach(function (c, i) {
            if (c.ColumnName === name) {
                stCol = c;
            }
        });
        return stCol;
    }

    return rtn;
};



export const currentUser = () => {
    let userName = "devEnvironment";
    if (typeof(window.parent) !== "undefined" && window.parent !== null) {
        if (typeof(window.parent.appUser) !== "undefined") {
            userName = window.parent.appUser.userName;
        }
    }
    return userName; 
};

export const correlatorUser = () => {
    let correlatorUser = {
        userName: "devUser",
        firstName: "Development",
        lastName: "User",
        roles: ["Technicians", "SurveyManager", "Administrators", "SurveyViewer"],
        areas: ["CA-Calgary", "CA-Edmonton", "CA-FortStJohn", "CA-Lloydminster", "CA-Montreal", "CA-Saskatoon","CA-Toronto"]
    };
    if (typeof (window.parent) !== "undefined" && window.parent !== null) {
        if (typeof (window.parent.appUser) !== "undefined") {
            correlatorUser = window.parent.appUser;
        }
    }
    return correlatorUser;
};

